module.exports = __webpack_public_path__ + "img/areaInterest-icon.a6fa3895.svg";